
/* Riviera Tiles Studio — formats et variantes Shopify */
document.addEventListener('DOMContentLoaded', () => {
  const $ = (s) => document.querySelector(s);
  const widthSelect = $('#riviera-grid-width');
  const heightSelect = $('#riviera-grid-height');
  const createButton = $('#riviera-create-grid');
  const grid = $('#riviera-grid');

  if (!widthSelect || !heightSelect || !createButton ||
      !grid || !$('#riviera-product-list')) return;

  const list = $('#riviera-product-list');
  const status = $('#riviera-product-status');
  const search = $('#riviera-search');
  const dimensions = $('#riviera-dimensions');
  const count = $('#riviera-count');
  const filled = $('#riviera-filled-count');
  const price = $('#riviera-total-price');
  const cartButton = $('#riviera-add-cart');
  const cartMessage = $('#riviera-cart-message');
  const preview = $('#riviera-preview-modal');
  const previewGrid = $('#riviera-preview-grid');

  const collectionButtons = [
    ...document.querySelectorAll('.riviera-collection-button')
  ];

  let handle = 'icones-de-la-riviera';
  let products = [];
  let composition = [];
  let selected = 0;
  let requestToken = 0;
  let tileSize = 15;
  let styleFilter = 'all';

  const money = (c) =>
    new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(c / 100);

  const isIcon = () => handle === 'icones-de-la-riviera';

  const totalCells = () =>
    Number(widthSelect.value) * Number(heightSelect.value);

  const dimensionsValue = () =>
    `${Number(widthSelect.value) * tileSize} × ${Number(heightSelect.value) * tileSize} cm`;

  const controls = $('.riviera-configurator__controls');
  const picker = document.createElement('div');
  picker.className = 'riviera-new-options';

  picker.innerHTML = `
    <fieldset class="riviera-size-options">
      <legend>Format des carreaux</legend>
      <label>
        <input type="radio" name="riviera-tile-size" value="11">
        11 × 11 cm
      </label>
      <label>
        <input type="radio" name="riviera-tile-size" value="15" checked>
        15 × 15 cm
      </label>
    </fieldset>

    <fieldset class="riviera-style-options">
      <legend>Style du carreau — Icônes de la Riviera</legend>
      <label>
        <input type="radio" name="riviera-style" value="all" checked>
        Tous
      </label>
      <label>
        <input type="radio" name="riviera-style" value="motif">
        Motif seul
      </label>
      <label>
        <input type="radio" name="riviera-style" value="coins">
        Coins Delft
      </label>
      <label>
        <input type="radio" name="riviera-style" value="double">
        Double Delft
      </label>
    </fieldset>
  `;

  controls.parentNode.insertBefore(picker, controls);

  const styleBox = picker.querySelector('.riviera-style-options');

  const css = document.createElement('style');
  css.textContent = `
    .riviera-new-options {
      max-width:900px;
      margin:18px auto;
      text-align:center;
      color:#203d4c;
    }
    .riviera-new-options fieldset {
      border:0;
      padding:0;
      margin:0 0 16px;
    }
    .riviera-new-options legend {
      font-weight:600;
      margin:0 auto 10px;
    }
    .riviera-new-options label {
      display:inline-flex;
      align-items:center;
      gap:5px;
      margin:3px 5px;
      padding:8px 12px;
      border:1px solid #a9b5bc;
      border-radius:24px;
      cursor:pointer;
      font-size:13px;
    }
    .riviera-new-options label:has(input:checked) {
      background:#203d4c;
      color:#fff;
      border-color:#203d4c;
    }
    .riviera-new-options input {
      accent-color:#203d4c;
    }
    .riviera-product-card__info small {
      display:block;
      font-size:11px;
      opacity:.8;
      margin-top:4px;
    }
    .riviera-configurator__grid {
      min-width:0!important;
    }
    .riviera-configurator__cell {
      min-width:0;
      aspect-ratio:1/1;
    }
    .riviera-configurator__cell img,
    .riviera-preview-tile img {
      width:100%;
      height:100%;
      object-fit:cover;
    }
    @media(max-width:749px) {
      .riviera-new-options label {
        font-size:12px;
        padding:7px 9px;
      }
    }
  `;
  document.head.appendChild(css);

  const updateSizeLabels = () => {
    if (dimensions) dimensions.textContent = dimensionsValue();
    if (count) count.textContent = `${composition.length} carreaux`;
  };

  function createGrid() {
    composition = Array(totalCells()).fill(null);
    selected = 0;
    grid.style.gridTemplateColumns =
      `repeat(${Number(widthSelect.value)}, minmax(0,1fr))`;
    updateSizeLabels();
    renderGrid();
    update();
  }

  function renderGrid() {
    grid.replaceChildren();

    composition.forEach((item, i) => {
      const cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'riviera-configurator__cell' +
        (i === selected ? ' is-selected' : '');

      cell.setAttribute(
        'aria-label',
        `Case ${i + 1}${item ? ', ' + item.title : ''}`
      );

      if (item?.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title;
        img.loading = 'lazy';
        cell.append(img);
      } else {
        const plus = document.createElement('span');
        plus.className = 'riviera-plus';
        plus.textContent = '+';
        cell.append(plus);
      }

      const num = document.createElement('span');
      num.className = 'riviera-cell-number';
      num.textContent = i + 1;
      cell.append(num);

      cell.addEventListener('click', () => {
        selected = i;
        renderGrid();
      });

      grid.append(cell);
    });
  }

  function parseSize(v) {
    const s = String(v || '')
      .toLowerCase()
      .replace(/\s/g, '');

    if (/(^|\D)11(?:[x×]11|cm|$)/.test(s)) return 11;
    if (/(^|\D)15(?:[x×]15|cm|$)/.test(s)) return 15;
    return null;
  }

  function parseStyle(v) {
    const s = String(v || '').toLowerCase();

    if (/double\s*delft/.test(s)) return 'double';
    if (/coins?\s*delft/.test(s)) return 'coins';
    if (/motif\s*seul|vierge|sans\s*bordure/.test(s))
      return 'motif';

    return null;
  }

  function variantImage(product, variant) {
    const images = product.images || [];
    const featured = variant.featured_image;

    if (featured?.src) return featured.src;

    const match = images.find(im =>
      (im.variant_ids || [])
        .map(String)
        .includes(String(variant.id))
    );

    if (match?.src) return match.src;

    return images[1]?.src ||
           images[0]?.src ||
           product.image?.src ||
           '';
  }

  function normalize(product) {
    const variants = product.variants || [];

    return variants.map(v => {
      const options = [
        v.option1, v.option2, v.option3, v.title
      ].filter(Boolean);

      const size = options.map(parseSize).find(Boolean);
      const style = options.map(parseStyle).find(Boolean);
      const isLink = product.handle?.includes('carreau-de-liaison');

      return {
        id: product.id,
        handle: product.handle,
        title: product.title,
        variantId: Number(v.id),
        size,
        style,
        price: Math.round(Number(v.price) * 100),
        image: variantImage(product, v),
        previewImage: variantImage(product, v),
        available: v.available !== false,
        variantTitle: v.title || '',
        isLink
      };
    }).filter(v =>
      v.size === tileSize &&
      v.available &&
      (!isIcon() || v.style || v.isLink || variants.length <= 2)
    );
  }

  async function loadProducts(newHandle) {
    handle = newHandle;
    styleBox.hidden = !isIcon();

    const token = ++requestToken;
    products = [];
    list.replaceChildren();

    if (status) status.textContent = 'Chargement…';
    if (search) search.value = '';

    try {
      let all = [];

      for (let page = 1; page <= 10; page++) {
        const response = await fetch(
          `/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`
        );

        if (!response.ok)
          throw Error('Chargement impossible');

        const data = await response.json();
        if (token !== requestToken) return;

        const batch = data.products || [];
        all.push(...batch);

        if (batch.length < 250) break;
      }

      products = all.flatMap(normalize);
      renderProducts();

    } catch (err) {
      if (token !== requestToken) return;

      console.error('Riviera Studio', err);

      if (status)
        status.textContent = 'Erreur de chargement';

      list.textContent =
        'Impossible de charger les produits. Réessayez.';
    }
  }

  function renderProducts() {
    const term = (search?.value || '').toLowerCase().trim();

    const visible = products.filter(p =>
      (styleFilter === 'all' ||
       !isIcon() ||
       p.style === styleFilter) &&
      (p.title.toLowerCase().includes(term) ||
       p.variantTitle.toLowerCase().includes(term))
    );

    list.replaceChildren();

    if (status) {
      status.textContent =
        `${visible.length} modèles disponibles`;
    }

    visible.forEach(item => {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'riviera-product-card';

      const img = document.createElement('img');
      img.src = item.image;
      img.alt = item.title;
      img.loading = 'lazy';

      const info = document.createElement('div');
      info.className = 'riviera-product-card__info';

      const name = document.createElement('strong');
      name.textContent = item.title;

      const detail = document.createElement('small');
      detail.textContent =
        `${item.size} × ${item.size} cm` +
        (item.style ? ` · ${item.variantTitle}` : '');

      const amount = document.createElement('span');
      amount.textContent = money(item.price);

      info.append(name, detail, amount);
      card.append(img, info);

      card.addEventListener('click', () => {
        composition[selected] = item;
        selected = Math.min(selected + 1, composition.length - 1);
        renderGrid();
        update();
      });

      list.append(card);
    });

    if (!visible.length) {
      const empty = document.createElement('p');
      empty.textContent =
        'Aucun carreau disponible pour cette sélection.';
      list.append(empty);
    }
  }

  function update() {
    const chosen = composition.filter(Boolean);
    const complete =
      composition.length > 0 &&
      chosen.length === composition.length;

    if (filled) {
      filled.textContent =
        `${chosen.length} / ${composition.length} choisis`;
    }

    if (price) {
      price.textContent = money(
        chosen.reduce((sum, p) => sum + p.price, 0)
      );
    }

    if (cartButton) cartButton.disabled = !complete;

    if (cartMessage) {
      cartMessage.textContent = complete
        ? 'Votre composition est prête à être commandée.'
        : 'Remplissez toutes les cases pour commander votre composition.';
    }

    updateSizeLabels();
  }

  function renderPreview() {
    if (!previewGrid) return;

    previewGrid.replaceChildren();
    previewGrid.style.gridTemplateColumns =
      `repeat(${Number(widthSelect.value)}, minmax(0,1fr))`;

    composition.forEach(item => {
      const cell = document.createElement('div');
      cell.className = 'riviera-preview-tile';

      if (item?.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title;
        cell.append(img);
      }

      previewGrid.append(cell);
    });

    const label = $('#riviera-preview-dimensions');
    if (label) label.textContent = dimensionsValue();
  }

  function closePreview() {
    if (!preview) return;
    preview.classList.remove('is-open');
    preview.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  $('#riviera-preview-open')?.addEventListener('click', () => {
    if (!preview) return;
    renderPreview();
    preview.classList.add('is-open');
    preview.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  });

  $('#riviera-preview-close')?.addEventListener(
    'click', closePreview
  );

  $('#riviera-preview-close-bottom')?.addEventListener(
    'click', closePreview
  );

  preview?.querySelector('.riviera-preview-modal__overlay')
    ?.addEventListener('click', closePreview);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closePreview();
  });

  $('#riviera-clear-cell')?.addEventListener('click', () => {
    composition[selected] = null;
    renderGrid();
    update();
  });

  $('#riviera-clear-all')?.addEventListener('click', () => {
    composition.fill(null);
    selected = 0;
    renderGrid();
    update();
  });

  createButton.addEventListener('click', createGrid);

  picker.querySelectorAll('[name="riviera-tile-size"]')
    .forEach(input => {
      input.addEventListener('change', () => {
        const nextSize = Number(input.value);
        if (nextSize === tileSize) return;

        if (composition.some(Boolean)) {
          const ok = confirm(
            'Changer le format effacera votre composition actuelle. Continuer ?'
          );

          if (!ok) {
            picker.querySelector(
              `[name="riviera-tile-size"][value="${tileSize}"]`
            ).checked = true;
            return;
          }
        }

        tileSize = nextSize;
        createGrid();
        loadProducts(handle);
      });
    });

  picker.querySelectorAll('[name="riviera-style"]')
    .forEach(input => {
      input.addEventListener('change', () => {
        styleFilter = input.value;
        renderProducts();
      });
    });

  collectionButtons.forEach(button => {
    button.addEventListener('click', () => {
      const nextHandle = button.dataset.handle;
      if (!nextHandle || nextHandle === handle) return;

      if (composition.some(Boolean)) {
        const ok = confirm(
          'Changer de collection effacera votre composition. Continuer ?'
        );
        if (!ok) return;
      }

      collectionButtons.forEach(b =>
        b.classList.toggle('is-active', b === button)
      );

      const title = $('#riviera-current-collection');
      if (title) title.textContent = button.dataset.name;

      styleFilter = 'all';

      const allStyle = picker.querySelector(
        '[name="riviera-style"][value="all"]'
      );
      if (allStyle) allStyle.checked = true;

      createGrid();
      loadProducts(nextHandle);
    });
  });

  search?.addEventListener('input', renderProducts);

  cartButton?.addEventListener('click', async () => {
    if (composition.some(item => !item)) return;

    const quantities = new Map();

    composition.forEach(item => {
      quantities.set(
        item.variantId,
        (quantities.get(item.variantId) || 0) + 1
      );
    });

    const items = [...quantities].map(([id, quantity]) => ({
      id,
      quantity,
      properties: {
        'Composition': 'Riviera Tiles Studio',
        'Dimensions': dimensionsValue(),
        'Format': `${tileSize} × ${tileSize} cm`
      }
    }));

    cartButton.disabled = true;
    cartButton.textContent = 'Ajout en cours…';

    try {
      const response = await fetch(
        (window.Shopify?.routes?.root || '/') + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(
          error.description || 'Impossible d’ajouter au panier'
        );
      }

      window.location.href =
        (window.Shopify?.routes?.root || '/') + 'cart';

    } catch (error) {
      console.error(error);
      if (cartMessage) {
        cartMessage.textContent = error.message;
      }
      cartButton.disabled = false;
      cartButton.textContent =
        'Ajouter cette composition au panier';
    }
  });

  $('#riviera-download-composition')?.addEventListener(
    'click', async () => {
      const columns = Number(widthSelect.value);
      const rows = Number(heightSelect.value);
      const cellSize = 400;

      const canvas = document.createElement('canvas');
      canvas.width = columns * cellSize;
      canvas.height = rows * cellSize;

      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < composition.length; i++) {
        const item = composition[i];
        const x = (i % columns) * cellSize;
        const y = Math.floor(i / columns) * cellSize;

        if (item?.image) {
          try {
            const image = new Image();
            image.crossOrigin = 'anonymous';
            image.src = item.image;

            await new Promise((resolve, reject) => {
              image.onload = resolve;
              image.onerror = reject;
            });

            ctx.drawImage(
              image, x, y, cellSize, cellSize
            );
          } catch (error) {
            console.warn('Image non exportable', item.image);
          }
        }

        ctx.strokeStyle = '#d8d8d8';
        ctx.lineWidth = 2;
        ctx.strokeRect(x, y, cellSize, cellSize);
      }

      try {
        const link = document.createElement('a');
        link.download = 'composition-riviera-tiles.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
      } catch (error) {
        alert('Impossible de télécharger cette composition.');
      }
    }
  );

  createGrid();
  loadProducts(handle);
});
